module.exports = __webpack_public_path__ + "static/media/camp3.b28072f5.jpeg";